<template>
	<div :class="{ hideSidebar: hideSidebar }">
		<Navbar :backlink="backlink" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle">
			<template #bar>
				<slot name="bar"></slot>
			</template>
		</Navbar>
		<div class="main">
			<PageHeader :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :backlink="backlink">
				<template #head><slot name="head"></slot></template>
				<template #breadcrumb><slot name="breadcrumb"></slot></template>
				<template #cta><slot name="cta"></slot></template>
			</PageHeader>
			<div class="">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
import Navbar from "@/components/layout/Navbar"
import PageHeader from "@/components/layout/PageHeader"

export default {
	name: "Layout",
	props: {
		pageTitle: { default: "" },
		pageSubtitle: { default: "" },
		backlink: { default: "" },
		hideSidebar: { default: false }
	},
	components: {
		Navbar,
		PageHeader
	}
}
</script>

<style scoped>
.main {
	width: calc(100% - 256px);
	margin-left: 256px;
}
.main-container {
	padding: 18px;
}

@media (max-width: 991px) {
	.main {
		width: 100%;
		margin-left: 0px;
	}
	.main-container {
		padding: 0px;
	}
}
</style>
